import ovbs_contents from '$lib/data/ovbs_contents.js';
import ovbs_landing from '$lib/data/ovbs_landing.js';
import { resolve } from '$lib/utils.js';

const isSongBook = (title) => title.replaceAll(' ', '').toLowerCase().includes('songbook');

export async function load({ params }) {
	const ovbsData = await resolve({
		ovbs_landing: ovbs_landing(params.year),
		ovbs_contents: ovbs_contents(params.year)
	});
	let ovbsItems = [];
	if (ovbsData?.ovbs_contents) {
		let audios = ovbsData?.ovbs_contents.filter(
			(item) => item.field_gallery_item.type == 'media--audio'
		);
		let videos = ovbsData?.ovbs_contents.filter(
			(item) =>
				item.field_gallery_item.type == 'media--video' ||
				item.field_gallery_item.type == 'media--remote_video'
		);

		let songBooks = ovbsData?.ovbs_contents.filter((item) => isSongBook(item.title));

		let books = ovbsData?.ovbs_contents.filter(
			(item) => !isSongBook(item.title) && item.field_gallery_item.type == 'media--document'
		);
		ovbsItems = [
			{
				name: 'Books',
				collections: [
					{
						name: 'Books',
						collections: books
					},
					{
						name: 'Song Books',
						collections: songBooks
					}
				]
			},
			{
				name: 'Audios',
				collections: audios
			},
			{
				name: 'Videos',
				collections: videos
			}
		];
	}

	return {
		ovbs_landing: ovbsData?.ovbs_landing,
		ovbs_items: ovbsItems
	};
}
